import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DevFlag, injectDevFlag } from '@recruitee/dev-flags/data';
import {
  ActivitySubscriptions,
  ActivitySubscriptionType,
  ActivitySubscriptionUpdateData,
} from '@recruitee/http/types';
import { TranslatePipe } from '@recruitee/i18n';
import { ReferralsService } from '@recruitee/referrals';
import { LifeCycle } from '@recruitee/utils';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-company',
  templateUrl: './activity-subscriptions-company.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  standalone: true,
  imports: [
    TranslatePipe,
    ActivitySubscriptionsTableComponent,
    ActivitySubscriptionsTableRowComponent,
  ],
})
export class ActivitySubscriptionsCompanyComponent {
  @Input() public types: ActivitySubscriptionType[];
  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Input() public abilities = {
    viewAllOffers: false,
    manageRecruiters: false,
    shareCandidates: false,
    manageCandidates: false,
    manageAttributes: false,
    manageDisqualifyReasons: false,
    manageReferrals: false,
    manageTexting: false,
    viewRequisitions: false,
    manageLocations: false,
  };
  @Input() public hasRequisitions = false;

  @Output() public changeEvents: EventEmitter<ActivitySubscriptionUpdateData> = new EventEmitter();
  public canViewActivitySubscriptions = false;

  public hasReferrals: boolean = this.referralsService.hasReferralsAndReferralsFlag();
  public hasManageLocationsFeature = injectDevFlag(DevFlag.ManageLocations);

  @LifeCycle('onDestroy')
  private ngOnDestroy$: Observable<void>;

  constructor(
    private referralsService: ReferralsService,
    private store: Store,
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ('abilities' in changes) {
      const { manageReferrals, ...restAbilities } = changes.abilities.currentValue;
      this.canViewActivitySubscriptions =
        restAbilities.viewAllOffers ||
        restAbilities.manageRecruiters ||
        restAbilities.shareCandidates ||
        restAbilities.manageCandidates ||
        restAbilities.manageAttributes ||
        restAbilities.manageDisqualifyReasons ||
        restAbilities.viewRequisitions ||
        restAbilities.manageTexting ||
        restAbilities.manageLocations ||
        (this.hasReferrals && manageReferrals);
    }
  }
}
